import { Injectable, inject } from '@angular/core';
import { BaseApiService, PaginatedResults } from '@bo/ng-api';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CardTopupRequest, CardTopup, CardTopupType } from '../../../_interfaces/card-topups.interface';

@Injectable({
  providedIn: 'root',
})
export class CardTopupsApiService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_TOPUP_RULE: string = 'topup-rule';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  /**
   * Create a top-up rule
   *
   * @param data
   * @return Observable<CardTopupRequest>
   */
  createTopupRule(data: CardTopupRequest) {
    return this.http.post<CardTopupRequest>(this.getUrl(this.URL_TOPUP_RULE, true), data);
  }

  /**
   * Remove a top-up rule
   *
   * @return Observable<Record<PropertyKey, never>>
   * @param ruleId
   */
  removeTopupRule(ruleId: string): Observable<Record<PropertyKey, never>> {
    const url = this.getUrl([this.URL_TOPUP_RULE, ruleId], true);
    return this.http.delete<Record<PropertyKey, never>>(url);
  }

  /**
   * Get paginated recurring topup rules
   *
   * @return Observable<CardTopup>
   * @param queryParams
   */
  getRecurringTopups(queryParams: HttpParams): Observable<PaginatedResults<CardTopup>> {
    const url = this.getUrl(this.URL_TOPUP_RULE, true);
    queryParams = queryParams.appendAll({ 'type': CardTopupType.Recurring, 'is_removed': false });
    return this.http.get<PaginatedResults<CardTopup>>(url, { observe: 'response', params: queryParams }).pipe(
      map((res) => {
        return new PaginatedResults<CardTopup>(res);
      }),
    );
  }

  /**
   * Request employee details by ID
   *
   * @param ruleId
   * @return Observable<CardTopup>
   */
  getTopupRuleById(ruleId: string): Observable<CardTopup> {
    const url = this.getUrl([this.URL_TOPUP_RULE, ruleId], true);
    return this.http.get<CardTopup>(url);
  }

  /**
   * Get all scheduled topups
   *
   * @return Observable<CardTopup>
   * @param queryParams
   */
  getScheduledTopups(queryParams: HttpParams): Observable<PaginatedResults<CardTopup>> {
    const url = this.getUrl(this.URL_TOPUP_RULE, true);
    queryParams = queryParams.append('type', CardTopupType.Scheduled);
    return this.http.get<PaginatedResults<CardTopup>>(url, { observe: 'response', params: queryParams }).pipe(
      map((res) => {
        return new PaginatedResults<CardTopup>(res);
      }),
    );
  }
}
